var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_53301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.971 69.202C207.331 66.5418 216.597 63.6333 226.026 61.2783C227.967 60.777 230.414 62.3554 232.624 62.9352C227.836 61.6788 226.125 63.6551 224.276 68.3823C219.297 80.6915 214.283 92.1618 206.879 103.452C189.643 129.607 167.429 149.275 137.081 158.64C116.997 164.857 96.8167 164.721 76.9932 157.678C60.5274 151.868 49.2527 144.889 33.4842 129.581C29.5986 125.094 26.769 120.394 22.5582 116.172L197.971 69.202Z",
    fill: "url(#paint0_linear_336_53301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.04 78.1803C228.851 74.396 219.168 98.4464 221.094 94.7127C220.46 95.5273 224.064 95.8888 223.487 96.7287C217.161 106.387 208.892 114.091 201.694 123.09C189.516 138.237 177.44 153.154 159.766 161.697C154.889 164.057 149.922 166.31 144.93 168.62C145.191 168.804 145.477 168.93 145.738 169.114C143.578 169.665 141.469 170.101 139.219 170.543C138.146 170.959 137.155 171.342 136.082 171.757C135.522 171.783 134.88 171.842 134.321 171.868L134.378 171.894C133.661 172.124 132.975 172.436 132.257 172.667L132.282 172.609C88.1624 182.601 36.5594 162.323 17.3027 120.143C14.5127 123.974 16.9535 127.585 18.2305 130.886C44.3538 203.337 142.885 227.387 200.351 176.557C224.756 149.707 243.401 114.838 235.231 70.031C231.204 82.0737 233.255 66.7625 227.04 78.1803Z",
    fill: "url(#paint1_linear_336_53301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.936 168.618C145.254 168.827 145.572 169.036 145.973 169.213C143.723 169.656 141.474 170.099 139.25 170.484C141.156 169.89 143.004 169.27 144.936 168.618Z",
    fill: "#21B873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.113 171.699C137.187 171.284 138.178 170.901 139.251 170.486C138.235 170.926 137.161 171.341 136.113 171.699Z",
    fill: "#D8B2A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.287 172.608C133.005 172.378 133.691 172.066 134.409 171.835C133.691 172.066 133.03 172.321 132.287 172.608Z",
    fill: "#D8B2A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4 173.005C131.01 172.864 131.678 172.748 132.313 172.55C131.678 172.748 131.01 172.864 130.4 173.005Z",
    fill: "#D8B2A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.354 171.811C134.913 171.784 135.555 171.726 136.114 171.699C135.555 171.726 134.97 171.809 134.354 171.811Z",
    fill: "#D8B2A0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M144.934 168.618C145.195 168.802 145.482 168.928 145.742 169.112C143.582 169.663 141.473 170.099 139.224 170.542C138.15 170.957 137.159 171.34 136.086 171.755C135.526 171.782 134.885 171.84 134.325 171.867L134.383 171.892C133.665 172.122 132.979 172.435 132.261 172.665L132.286 172.608C129.929 173.14 127.54 173.59 125.119 173.957C132.119 178.556 138.432 183.468 148.509 181.421C157.105 178.856 158.974 171.539 160.709 164.368C160.961 163.179 161.214 161.991 161.466 160.802C160.92 161.108 160.316 161.389 159.713 161.669C154.893 164.055 149.869 166.283 144.934 168.618Z",
    fill: "url(#paint2_linear_336_53301)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M208.332 130.066C204.112 130.323 200.577 129.65 197.327 128.487C193.325 133.356 189.29 138.142 184.963 142.662C193.873 145.574 200.192 153.567 213.485 151.368C216.084 151.217 218.226 150.863 220.106 150.326C225.588 141.184 230.084 131.333 233.06 120.741C224.415 120.478 224.496 130.505 208.332 130.066Z",
    fill: "url(#paint3_linear_336_53301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7356 157.971C57.1851 163.971 62.5094 169.883 73.1208 174.984C81.9245 178.602 84.8633 176.137 88.5575 173.047C75.1217 170.462 62.1265 165.334 50.7356 157.971Z",
    fill: "url(#paint4_linear_336_53301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8274 142.223C31.8978 142.528 32.5408 143.086 33.47 143.771C32.9668 143.206 32.4384 142.699 31.9353 142.134C31.878 142.109 31.8527 142.166 31.8274 142.223Z",
    fill: "url(#paint5_linear_336_53301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8366 173.927C49.0923 173.598 50.0039 175.096 51.3866 177.076C55.8742 180.702 60.6536 183.978 65.6421 186.936C60.0713 181.736 56.4767 176.246 49.8366 173.927Z",
    fill: "url(#paint6_linear_336_53301)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M178.135 154.072C169.539 156.637 167.671 163.955 165.935 171.126C164.605 177.381 163.35 183.464 160.48 188.56C158.97 190.425 156.914 191.979 154.023 193.097C136.679 197.954 131.655 181.156 113.132 184.192C96.4672 185.038 96.3971 196.025 85.1914 196.136C114.423 206.798 147.836 206.307 176.364 192.57C177.135 189.9 178.135 187.331 179.428 185.028C180.937 183.163 182.994 181.609 185.884 180.491C189.868 179.377 193.205 179.415 196.149 180.032C197.551 178.873 199.011 177.739 200.382 176.497C203.472 173.073 206.447 169.597 209.301 165.932C198.576 161.397 191.796 151.351 178.135 154.072Z",
    fill: "url(#paint7_linear_336_53301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.314 69.9985C219.229 115.17 186.28 155.761 139.219 170.543C138.311 170.894 137.097 171.316 136.107 171.699C135.547 171.725 134.905 171.784 134.346 171.81L134.403 171.836C133.686 172.066 133 172.378 132.282 172.609L132.307 172.551C88.1875 182.543 36.5845 162.265 17.3279 120.085C18.0095 117.307 19.5829 115.608 22.5445 115.411C89.7568 200.344 193.353 158.956 223.413 65.491C226.391 56.1319 238.546 61.2997 235.314 69.9985Z",
    fill: "url(#paint8_linear_336_53301)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.16 168.515C145.085 168.55 145.01 168.585 144.935 168.62C145.065 168.712 145.202 168.789 145.339 168.867C145.476 168.944 145.612 169.022 145.743 169.114C143.583 169.664 141.473 170.1 139.224 170.543L136.086 171.756C135.806 171.769 135.506 171.79 135.206 171.811C134.905 171.833 134.605 171.854 134.325 171.867L134.383 171.892C134.024 172.007 133.673 172.143 133.322 172.279C132.971 172.414 132.62 172.55 132.261 172.665L132.286 172.608C88.1664 182.595 36.5599 162.313 17.2986 120.133C14.9604 123.343 16.2969 126.4 17.5428 129.249C17.7834 129.799 18.0207 130.341 18.2274 130.876C44.3585 203.326 142.895 227.384 200.358 176.562C224.737 149.742 243.367 114.918 235.253 70.1768C232.021 79.2305 228.111 88.099 223.545 96.6112C223.536 96.6526 223.518 96.6952 223.487 96.7392C223.466 96.7711 223.446 96.8029 223.425 96.8347C206.212 128.82 179.731 155.746 145.16 168.515Z",
    fill: "url(#paint9_radial_336_53301)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.04 88.2145C179.63 87.2176 178.644 85.5435 176.838 84.4753C175.031 83.4071 173.088 83.3493 172.498 84.3462C171.908 85.3432 172.895 87.0172 174.701 88.0854C176.508 89.1536 178.451 89.2114 179.04 88.2145ZM140.001 95.8856C141.01 97.7254 141.005 99.6682 139.989 100.225C138.973 100.782 137.331 99.7417 136.322 97.9019C135.313 96.0621 135.319 94.1193 136.335 93.5625C137.351 93.0057 138.992 94.0458 140.001 95.8856ZM158.157 99.0141C159.166 100.854 159.16 102.797 158.144 103.354C157.128 103.91 155.487 102.87 154.478 101.03C153.469 99.1906 153.474 97.2478 154.49 96.691C155.506 96.1342 157.148 97.1743 158.157 99.0141ZM132.498 118.174C132.93 120.228 132.36 122.085 131.227 122.324C130.093 122.562 128.823 121.09 128.392 119.037C127.96 116.984 128.529 115.126 129.663 114.888C130.797 114.65 132.066 116.121 132.498 118.174ZM78.9558 129.831C80.0907 130.065 81.3543 128.589 81.7781 126.534C82.202 124.479 81.6257 122.623 80.4908 122.389C79.356 122.156 78.0924 123.632 77.6685 125.687C77.2447 127.742 77.821 129.597 78.9558 129.831ZM103.188 108.506C102.835 110.574 101.622 112.093 100.48 111.898C99.338 111.703 98.6986 109.868 99.052 107.8C99.4054 105.732 100.618 104.213 101.76 104.408C102.902 104.603 103.542 106.438 103.188 108.506Z",
    fill: "url(#paint10_radial_336_53301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.612 133.311C113.571 133.312 113.531 133.313 113.49 133.313C111.423 133.154 109.982 136.19 110.218 140.105C110.451 143.941 112.253 147.194 114.281 147.434C114.321 147.433 114.362 147.432 114.362 147.432C116.429 147.592 117.87 144.556 117.635 140.64C117.401 136.804 115.599 133.512 113.612 133.311Z",
    fill: "url(#paint11_radial_336_53301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.578 123.329C151.537 123.328 151.497 123.327 151.457 123.326C149.399 123.068 147.815 126.032 147.864 129.954C147.915 133.797 149.56 137.131 151.575 137.467C151.616 137.468 151.656 137.469 151.656 137.469C153.714 137.726 155.298 134.763 155.249 130.841C155.157 126.997 153.553 123.663 151.578 123.329Z",
    fill: "url(#paint12_radial_336_53301)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.482 136.342C139.36 135.892 139.111 135.465 138.721 135.114C137.024 133.602 134.64 132.919 132.25 133.53C129.888 134.133 127.312 135.113 127.313 137.993C127.203 138.482 127.36 139.204 127.689 139.936C127.822 140.369 128.038 140.787 128.344 141.157C130.008 143.152 132.365 144.235 134.743 143.777C137.095 143.325 138.902 141.485 139.698 139.016C139.993 138.096 139.868 137.13 139.482 136.342Z",
    fill: "#6B160C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.383 142.929C131.711 143.731 133.223 144.069 134.744 143.776C137.095 143.324 138.902 141.484 139.698 139.015C139.968 138.172 139.886 137.29 139.573 136.543C137.563 135.92 135.3 136.186 133.424 137.496C131.566 138.793 130.501 140.818 130.383 142.929Z",
    fill: "url(#paint13_linear_336_53301)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_336_53301",
    x1: 232.89,
    y1: 93.6265,
    x2: 33.2353,
    y2: 150.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F55645"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_53301",
    x1: 91.0182,
    y1: 198.987,
    x2: 162.299,
    y2: 37.7276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C22C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_336_53301",
    x1: -152.106,
    y1: 221.583,
    x2: 6896.24,
    y2: -935.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15C65A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_336_53301",
    x1: -187.972,
    y1: 203.613,
    x2: 9281.79,
    y2: -1350.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15C65A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_336_53301",
    x1: -202.457,
    y1: 211.49,
    x2: 6274.61,
    y2: -851.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C22C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_336_53301",
    x1: 21.9558,
    y1: 144.701,
    x2: 276.316,
    y2: 102.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C22C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_336_53301",
    x1: 220.549,
    y1: 172.749,
    x2: -95.5546,
    y2: 187.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15C65A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_336_53301",
    x1: 220.673,
    y1: 175.55,
    x2: -95.4156,
    y2: 190.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15C65A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_336_53301",
    x1: 312.181,
    y1: 65.5887,
    x2: -4.4158,
    y2: 171.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BF39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAFBDB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_336_53301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.543 201.754) rotate(-13.1096) scale(179.335 51.2808)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#0D9E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#14B13C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_336_53301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.318 72.3991) rotate(57.9709) scale(133.974 133.948)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1635A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866166",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_336_53301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.926 140.373) rotate(88.9269) scale(7.07557 3.71489)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#882F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#681C14"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_336_53301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(151.556 130.397) rotate(91.6508) scale(7.07502 3.71587)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#882F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#681C14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_336_53301",
    x1: 142.411,
    y1: 147.087,
    x2: 142.246,
    y2: 146.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F75588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26161",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_53301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading9);
export default __webpack_public_path__ + "static/media/loading_9.661cc757fe986706e42c3e4d05a96297.svg";
export { ForwardRef as ReactComponent };